import { BrowserRouter, Route, Routes, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";
import { PrefsProvider } from "./lib/prefs";
import TopBar from "./components/TopBar";
import Landing from "./pages/Landing";
import AuthPage from "./pages/AuthPage";
import Course from "./pages/Course";
import Admin from "./pages/Admin";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import MagicConsume from "./pages/MagicConsume";
import SetPassword from "./pages/SetPassword";
import Continue from "./pages/Continue";
import Favorites from "./pages/Favorites";
import Quiz from "./pages/Quiz";
import "./App.css";

function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-center" style={{ color: "var(--ink-soft)" }}>loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function ConditionalTopBar() {
  const { pathname } = useLocation();
  // The /quiz page is a standalone dark landing experience — no app chrome.
  if (pathname.startsWith("/quiz")) return null;
  return <TopBar />;
}

function Shell() {
  return (
    <div className="App">
      <ConditionalTopBar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/quiz" element={<Quiz />} />
        <Route path="/login" element={<AuthPage mode="login" />} />
        <Route path="/signup" element={<AuthPage mode="signup" />} />
        <Route path="/continue" element={<RequireAuth><Continue /></RequireAuth>} />
        <Route path="/favorites" element={<RequireAuth><Favorites /></RequireAuth>} />
        <Route path="/course" element={<Course />} />
        <Route path="/course/:lessonId" element={<Course />} />
        <Route path="/admin" element={<RequireAuth><Admin /></RequireAuth>} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/auth/magic" element={<MagicConsume />} />
        <Route path="/auth/set-password" element={<SetPassword />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "var(--cream)",
            color: "var(--ink)",
            border: "1px solid var(--gold-soft)",
            borderRadius: "2px",
            fontFamily: "Inter, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <PrefsProvider>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
      </PrefsProvider>
    </AuthProvider>
  );
}
